export default "__VITE_ASSET__CUeR0mp9__"